module.exports = __webpack_public_path__ + "img/60c466b3e46963.78931227.e41d3511.png";